var module = angular.module('octopusApp.shared');

module.directive('scriptEditor', function($timeout) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      id: '@',
      body: '=',
      syntax: '=',
      syntaxFilter: '=',
      syntaxSelectionDisabled: '=',
      projectId: '=',
      machinePolicyId: '=',
      localNames: '=',
      noVariables: '='
    },
    templateUrl: 'areas/shared/views/script_editor.html',
    link: {
      pre: function($scope) {
        $scope.editor = null;

        $scope.allSyntaxes = [ 
          { id: 'PowerShell', display:'PowerShell', aceMode:'powershell'},
          { id: 'CSharp', display: 'C#', aceMode:'csharp'},
          { id: 'Bash', display: 'Bash', aceMode:'sh'},
          //FSharp mode is still work in progress: https://github.com/ajaxorg/ace/issues/2871 but because F# is based on Ocaml so we can use it instead for now.
          { id: 'FSharp', display: 'F#', aceMode:'ocaml'}
        ];
        $scope.syntaxes = $scope.allSyntaxes;

        if ($scope.syntaxFilter) {
          $scope.syntaxes = _.filter($scope.allSyntaxes, function(syntax) {
            return $scope.syntaxFilter.indexOf(syntax.id) >= 0;
          });
        }

        var syntaxMode = _.find($scope.syntaxes, function(syntax){ return $scope.syntax && $scope.syntax === syntax.id;});

        if (syntaxMode === undefined) {
          syntaxMode = $scope.syntaxes[0];
        }

        $scope.aceMode = syntaxMode.aceMode;

        $scope.editorLoaded = function(editor) {
          $scope.editor = editor;
          editor.$blockScrolling = Infinity;
          window.rend = $scope.editor.renderer;
        };

        $scope.insertVariable = function(variableReference) {
          if ($scope.editor) {
            $scope.editor.insert(variableReference);
            $scope.body = $scope.editor.getValue();
            return $scope.editor.getValue();
          }
          return null;
        };

        $scope.$on('octo-fullscreen-toggle', function() {
          $timeout(function() {
            if ($scope.editor) {
              $scope.editor.renderer.updateFull();
            }
          }, 200);
        });
      },
      post: function($scope) {
        $scope.$watch('syntax', function(newSyntax){
            if (newSyntax == null) {
                return;
            }
            $scope.aceMode = _.find($scope.syntaxes, function(syntax){ return newSyntax && newSyntax === syntax.id;}).aceMode;
            if($scope.aceMode && $scope.editor) {
                $scope.editor.getSession().setMode('ace/mode/' + $scope.aceMode);
            }
        });
        
        $scope.$watch('syntaxFilter', function(nv){
          if (nv != null) {
            $scope.syntaxes = _.filter($scope.allSyntaxes, function(syntax) {
              return nv.indexOf(syntax.id) >= 0;
            });
          }
        });
      }
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/script_editor.js
// module id = 268200080127165
// module chunks = 1